module.exports = import("workplace-dashboard");;